import {Button, Icon} from '@/components/atoms'
import usePageTitle from '@/hooks/usePageTitle'
import {useIntl} from 'react-intl'

const ErrorContent = ({errorType, isLoading, onClick}) => {
  const {formatMessage} = useIntl()

  usePageTitle(formatMessage({id: `PAGE_ERROR.${errorType}_HEADER`}))

  return (
    <div className="mt-20 text-center" data-testid="error-page">
      <div className="m-auto flex w-fit items-center gap-2">
        <Icon icon="mode" size="small" />
        <p className="text-2xl font-bold">{formatMessage({id: `PAGE_ERROR.${errorType}_HEADER`})}</p>
      </div>
      <p className="mt-2">{formatMessage({id: `PAGE_ERROR.${errorType}_SUBHEADER`})}</p>

      <div className="mt-8 w-full">
        <Button
          handleButton={onClick}
          uiSchema={{
            title: formatMessage({id: `PAGE_ERROR.${errorType}_RETURN_BUTTON`}),
            className: 'm-auto',
            isLoading: isLoading,
          }}
          data-testid="btn-return-login"
        />
      </div>
    </div>
  )
}

export default ErrorContent
